import { CourseService } from "./CourseService";

export { CourseService };
